import React, { useEffect, useState } from "react";
import { Tabs, Tab } from "react-bootstrap";
import SubscriptionDetails from "./SubscriptionDetails";
import UserDetails from "./UserDetails";
import DashboardDetails from "./DashboardDetails";
import { Helmet } from "react-helmet";
import AccountDetails from "./AccountDetails";
import OrganizationDetails from "./OrganizationDetails";
import ViewManagement from "./ViewManagement";
import InsightManagement from "./InsightManagement";
import PromptManagement from "./PromptManagement";
import TickerManagement from "./TickerManagement";
import PartnerKeyManagement from "./PartnerKeyManagement";
import "./AdminPanel.css";

const TAB_CONFIG = [
  { key: "user", title: "User", component: UserDetails },
  { key: "account", title: "Account", component: AccountDetails },
  { key: "organization", title: "Organization", component: OrganizationDetails },
  { key: "dashboard", title: "Dashboard", component: DashboardDetails },
  { key: "subscription", title: "Subscription", component: SubscriptionDetails },
  { key: "viewManagement", title: "View Management", component: ViewManagement },
  {
    key: "insightManagement",
    title: "Insight Management",
    component: InsightManagement,
  },
  {
    key: "promptManagement",
    title: "Prompt Management",
    component: PromptManagement,
  },
  {
    key: "tickerManagement",
    title: "Ticker Management",
    component: TickerManagement,
  },
  {
    key: "partnerKeys",
    title: "Partner API Keys",
    component: PartnerKeyManagement,
  },
];

function AdminPanel() {
  const [activeKey, setActiveKey] = useState("user");

  // Modals render in a portal; this lets AdminPanel.css scope their styling.
  useEffect(() => {
    document.body.classList.add("ap-active");
    return () => document.body.classList.remove("ap-active");
  }, []);

  const renderTabContent = () => {
    const activeTab = TAB_CONFIG.find((tab) => tab.key === activeKey);
    const Component = activeTab?.component;
    return Component ? <Component /> : null;
  };

  return (
    <>
      <Helmet>
        <title>Admin Panel | EMAlpha</title>
      </Helmet>
      <div className="admin-panel-wrapper ap-page">
        <div className="ap-shell">
          <header className="ap-header">
            <div className="ap-header-text">
              <span className="ap-eyebrow">Administration</span>
              <h1 className="ap-title">Admin Panel</h1>
              <p className="ap-subtitle">
                Manage users, accounts, subscriptions, content and prompts
              </p>
            </div>
          </header>

          <div className="tabs-container ap-panel">
            <Tabs
              activeKey={activeKey}
              onSelect={(key) => key && setActiveKey(key)}
              id="admin-panel-tabs"
              className="ap-tabs"
            >
              {TAB_CONFIG.map((tab) => (
                <Tab key={tab.key} eventKey={tab.key} title={tab.title} />
              ))}
            </Tabs>

            {/* Render only the active tab's component here */}
            <div className="tab-content ap-content">{renderTabContent()}</div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AdminPanel;
